export const CATALOG_CART_WIDTH = 300;

export const CATALOG_PRODUCT_TYPE = {
  PRODUCT: 'Product',
  PACK: 'Pack'
};
